import React from 'react';
import { Link } from 'react-router-dom';

import Footer from '../../../components/Footer';
import { homepageCalculatorLinks } from '../../../SEO/config/calculatorPages';
import { homepagePriceLinks } from '../../../SEO/config/seoPriceLinks';
import { landingFaq } from '../../../faq/faq';
import { LandingCta, LandingFaq, LandingPricing, LandingSection, LandingSectionHeader } from '../../components';

function PricingSection() {
  return <LandingSection id="pricing" soft className="landing-section-pricing">
    <LandingPricing />
    <LandingSectionHeader eyebrow="Popular Precious Metals Price APIs" title="Explore Market Price APIs" description="Access live and historical gold, silver, platinum, and palladium prices across major currencies with GoldAPI.io." />
    <div className="row landing-card-grid popular-price-link-grid mb-5">
      {homepagePriceLinks.map(link => <div key={link.to} className="col-sm-6 col-lg-3 mb-3"><Link className="landing-info-card popular-price-link-card h-100" to={link.to}>{link.label}</Link></div>)}
    </div>
    <div className="landing-section-head text-center"><span className="lead text-muted">Popular Metal Calculators</span></div>
    <div className="row landing-card-grid popular-price-link-grid mb-5">
      {homepageCalculatorLinks.map(link => <div key={link.to} className="col-sm-6 col-lg-3 mb-3"><Link className="landing-info-card popular-price-link-card h-100" to={link.to}>{link.label}</Link></div>)}
    </div>
    <LandingFaq title="Frequently Asked Questions" subtitle="Learn more about GoldAPI.io live and historical precious metals price API." items={landingFaq} />
    <LandingCta />
    <Footer />
  </LandingSection>;
}

export default PricingSection;
